import { Button } from '@/common/components/button';

/**
 * Displays a message to the screen whenever route or route data is not found.
 */
export function RootNotFound() {
  return (
    <div
      className="flex size-full mt-52 flex-col items-center justify-center"
      role="alert"
    >
      <h2 className="text-lg font-semibold">It doesn't look like we have this...</h2>
      <Button href="/" className="mt-4">
        Home
      </Button>
    </div>
  );
}
